export const BOOKING_ENGINE_FORM_SELECTOR = '#booking';
